import React from "react";
import { ReactComponent as QuestionIcon } from "../../img/Question_icon.svg";
import {
	StyledCancelLink,
	Row,
	StyledBadge,
	StyledCardBilled,
	StyledCardContainer,
	StyledCardHeader,
	StyledCardPrice,
	StyledCardSessions,
	StyledCardTitle,
	StyledCrossedPrice,
	StyledMonth,
	StyledPrice
} from "./plans.style";
import Tooltip from "../utils/Tooltip";
import LinkButton from "../linkButton/LinkButton.component";
import { useHistory } from "react-router-dom";

const PlanCard = ({ activePlan, plan, applyCoupon, coupon }) => {
	const { id, name } = plan;
	const history = useHistory();
	const activePlanType = activePlan?.type.toLowerCase();
	const isActivePlan = activePlan?.state?.toLowerCase() === "active";
	const isCurrentActivePlan = activePlanType?.toLowerCase() === name?.replace(" ", "_").toLowerCase() && isActivePlan;

	const showOriginalPriceCrossed = applyCoupon && plan.originalPrice;
	const showActivePlanOriginalPriceCrossed = activePlan?.price && isCurrentActivePlan && parseFloat(activePlan?.price) !== parseFloat(plan.price) && !plan.originalPrice;
	const cantSubscribe = isCurrentActivePlan && !plan.originalPrice;

	const cancelPlan = () => {
		history.push({ pathname: `/plans/cancel/${plan.name.replace(" ", "-").toLowerCase()}`, state: { name: plan.name, id: activePlan.plan_id } });
	};
	return (
		<StyledCardContainer>
			{isCurrentActivePlan && <StyledBadge>ACTIVE</StyledBadge>}
			<StyledCardHeader>
				<StyledCardTitle>{plan.name}</StyledCardTitle>
				<StyledCardPrice>
					<Row>
						{showOriginalPriceCrossed ? <StyledCrossedPrice>${plan.originalPrice}</StyledCrossedPrice> : null}
						{showActivePlanOriginalPriceCrossed ? <StyledCrossedPrice>${plan.price}</StyledCrossedPrice> : null}
						<StyledPrice>${cantSubscribe ? Math.round(activePlan?.price * 100) / 100 : plan.price}</StyledPrice>
						<span>/</span>
						<StyledMonth>month</StyledMonth>
					</Row>
				</StyledCardPrice>

				<StyledCardBilled>Billed monthly</StyledCardBilled>
			</StyledCardHeader>
			<StyledCardSessions>
				<span>{plan.terms}</span>
				<Tooltip content="A session is the period of time a user is actively engaged with your website (similar to Google Analytics sessions).">
					<QuestionIcon />
				</Tooltip>
			</StyledCardSessions>
			<LinkButton type="button" value={id} disabled={ isActivePlan && isCurrentActivePlan} to={{ pathname: `plans/subscribe/checkout/${plan.arrayId}`, plan: plan, coupon: coupon }}>
				{(isActivePlan && isCurrentActivePlan) || activePlanType === "trial" || !isActivePlan ? "subscribe" : "change plan"}
			</LinkButton>
			{isActivePlan && isCurrentActivePlan ? <StyledCancelLink onClick={cancelPlan}>cancel plan</StyledCancelLink> : null}
		</StyledCardContainer>
	);
};
export default PlanCard;
